// Require dependencies
import Vue from 'vue';
// Tell Vue to use the plugin
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);
